import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import USERS from '../../common/data/userDummyData';
import { demoPages } from '../../menu';
import { DropdownItem, DropdownMenu } from '../../components/bootstrap/Dropdown';
import Button from '../../components/bootstrap/Button';
import useDarkMode from '../../hooks/useDarkMode';
import Collapse from '../../components/bootstrap/Collapse';
import { NavigationLine } from '../Navigation/Navigation';
import Icon from '../../components/icon/Icon';
import useNavigationItemHandle from '../../hooks/useNavigationItemHandle';
import AuthModule from '../../modules/AuthModule';
import OidcModule from '../../modules/OidcModule';
import { cookieNameGenerator, getRequester, isEmptyObject } from '../../helpers/helpers';

const SSO_HOMEPAGE = process.env.REACT_APP_SSO_HOMEPAGE;
const IS_SSO = process.env.REACT_APP_SSO == 'true' || false;

const User = () => {
	const [, , removeCookie] = useCookies([cookieNameGenerator('ssocookies')]);
	const navigate = useNavigate();
	const handleItem = useNavigationItemHandle();
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();

	const [collapseStatus, setCollapseStatus] = useState(false);

	const { t } = useTranslation(['translation', 'menu']);
	const { person_name, position_name, department, auth_type, photo } = getRequester();

	const handleNavigate = () => {
		// Sesi yang lahir dari OIDC diakhiri DI OP, bukan cuma di sini. Tanpa
		// langkah ini OP tidak pernah tahu sesinya berakhir, tidak menerbitkan
		// `logout_token`, dan aplikasi One LNK lain membiarkan pengguna tetap
		// masuk. `tujuanLogout()` mengembalikan null untuk sesi guest dan jalur
		// lama, sehingga perilaku mereka tidak berubah sama sekali.
		const tujuanOidc = OidcModule.tujuanLogout();
		if (tujuanOidc) {
			AuthModule.goONELNKHomapage();
			window.location.href = tujuanOidc;
			return;
		}
		if (!IS_SSO) {
			AuthModule.logout(removeCookie);
			if (auth_type === 'guest') {
				navigate('../login-guest');
			} else {
				navigate(`../login`);
			}
			window.location.reload();
		}
		if (IS_SSO) {
			if (auth_type === 'guest') {
				AuthModule.logout(removeCookie);
				navigate('../login-guest');
				window.location.reload();
			} else {
				AuthModule.goONELNKHomapage();
				window.location.href = SSO_HOMEPAGE;
			}
		}
	};
	return (
		<>
			<div
				className={classNames('user', { open: collapseStatus })}
				role='presentation'
				onClick={() => setCollapseStatus(!collapseStatus)}>
				<div className='user-avatar'>
					<img
						srcSet={
							photo && !isEmptyObject(photo) && photo.error === undefined
								? `data:${photo?.mimetype};base64,${photo?.file}`
								: USERS.JOHN.srcSet
						}
						src={
							photo && !isEmptyObject(photo) && photo.error === undefined
								? `data:${photo?.mimetype};base64,${photo?.file}`
								: USERS.JOHN.src
						}
						alt='Avatar'
						width={128}
						height={128}
					/>
				</div>
				<div className='user-info'>
					<div className='user-name d-flex align-items-center'>
						{`${person_name} `}
						<Icon icon='Verified' className='ms-1' color='info' />
					</div>
					<div className='user-sub-title'>
						{department} {position_name}
					</div>
				</div>
			</div>
			<DropdownMenu>
				<DropdownItem>
					<Button
						icon='AccountBox'
						onClick={() =>
							navigate(
								`../${demoPages.appointment.subMenu.employeeID.path}/${USERS.JOHN.id}`,
							)
						}>
						Profile
					</Button>
				</DropdownItem>
				<DropdownItem>
					<Button
						icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
						onClick={() => setDarkModeStatus(!darkModeStatus)}
						aria-label='Toggle fullscreen'>
						{darkModeStatus ? 'Dark Mode' : 'Light Mode'}
					</Button>
				</DropdownItem>
			</DropdownMenu>

			<Collapse isOpen={collapseStatus} className='user-menu'>
				{department === 'vendor' ? (
					<nav aria-label='aside-bottom-user-menu'>
						<div className='navigation'>
							<div
								role='presentation'
								className='navigation-item cursor-pointer'
								onClick={() => navigate('profile', handleItem())}>
								<span className='navigation-link navigation-link-pill'>
									<span className='navigation-link-info'>
										<Icon icon='AccountBox' className='navigation-icon' />
										<span className='navigation-text'>{t('menu:Profile')}</span>
									</span>
								</span>
							</div>
						</div>
					</nav>
				) : (
					''
				)}
				<NavigationLine />
				<nav aria-label='aside-bottom-user-menu-2'>
					<div className='navigation'>
						<div
							role='presentation'
							className='navigation-item cursor-pointer'
							onClick={() => {
								handleNavigate();
							}}>
							<span className='navigation-link navigation-link-pill'>
								<span className='navigation-link-info'>
									<Icon icon='Logout' className='navigation-icon' />
									<span className='navigation-text'>
										{!IS_SSO || auth_type === 'guest'
											? t('menu:Logout')
											: 'OneLNK HomePage'}
									</span>
								</span>
							</span>
						</div>
					</div>
				</nav>
			</Collapse>
		</>
	);
};

export default User;
